import type { SxProps, Theme } from '@mui/material';

// Scalar AI Gradient Colors - Based on the Color System
export const AI_GRADIENT_COLORS = {
  purple: '#A614FF',
  blue: '#1F55F8',
} as const;

// CSS linear-gradient string for use in background/border-image properties
export const AI_GRADIENT_CSS = `linear-gradient(90deg, ${AI_GRADIENT_COLORS.purple} 47.98%, ${AI_GRADIENT_COLORS.blue} 102.71%)`;

// MUI SX props for gradient text
export const aiGradientTextSx: SxProps<Theme> = {
  background: AI_GRADIENT_CSS,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
};

// SVG gradient stops for use in SVG <linearGradient> elements
export const AI_GRADIENT_STOPS = [
  { offset: '47.98%', color: AI_GRADIENT_COLORS.purple },
  { offset: '102.71%', color: AI_GRADIENT_COLORS.blue },
] as const;
